import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../ui/src/component/icon';
import './player.css';
import { getProp } from '../../../ui/src/utilities';

class Player extends React.Component {
  constructor(props) {
    super(props);

    this.streams = {
      128: 'https://stream.21.sk/radiokosice-128.mp3',
    };

    this.state = {
      source: this.streams['128'],
      playing: false,
      volume: 0,
      wasPlayingBeforePause: false,
    };

    this.audioEl = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.forcePause === true && this.props.forcePause === false) {
      if (this.state.playing) {
        this.setState({ wasPlayingBeforePause: true });
        this.stopStream();
      } else {
        this.setState({ wasPlayingBeforePause: false });
      }
    } else if (
      nextProps.forcePause === false &&
      this.props.forcePause === true
    ) {
      if (this.state.wasPlayingBeforePause) {
        this.playStream();
      }
      if (this.state.playing) {
        this.stopStream();
      }
    }
  }

  componentDidMount() {
    let hash = getProp(window.location, 'hash', '');
    // #play64 ostava kvoli starym odkazom, uz vsak spusti jediny stream (128)
    if (hash === '#play' || hash === '#play128' || hash === '#play64') {
      this.playStream();
    }

    this.setVolume(0.25);
  }

  get currentStreamValue() {
    let text = 0;
    Object.keys(this.streams).map((bitrate) => {
      if (this.streams[bitrate] === this.state.source) {
        text = bitrate;
      }
      return true;
    });
    return text;
  }

  playStream() {
    if (typeof window !== 'undefined' && window && window.ga) {
      window.ga(
        'send',
        'event',
        'onair',
        'play',
        `Prehratie rádia ${this.currentStreamValue}kbps`,
      );
    }
    this.setState({ playing: true }, () => {
      this.audioEl.play();
    });
  }

  stopStream() {
    if (typeof window !== 'undefined' && window && window.ga) {
      window.ga(
        'send',
        'event',
        'onair',
        'stop',
        `Prehratie rádia ${this.currentStreamValue}kbps`,
      );
    }
    this.setState({ playing: false }, () => {
      this.audioEl.pause();
    });
  }

  onClickPlay() {
    if (this.state.playing) {
      this.stopStream();
    } else {
      this.playStream();
    }
  }

  onChangeVolume(ev) {
    this.setVolume(ev.target.value);
  }

  setVolume(volume) {
    this.setState({ volume }, () => {
      this.audioEl.volume = this.state.volume;
    });
  }

  render() {
    return (
      <div className="player">
        <audio ref={(el) => (this.audioEl = el)} preload={'none'}>
          <source src={this.state.source} type="audio/mp3" />
        </audio>
        <div className="player-container">
          <div className="player-content">
            <a onClick={this.onClickPlay.bind(this)}>
              <Icon name={this.state.playing ? 'speaker' : 'speaker-mute'} />{' '}
              128&nbsp;Kbps
            </a>
            <div className="player-volume">
              <div
                className="player-volume-state"
                style={{ width: `${this.state.volume * 100}%` }}
              />
              <input
                type="range"
                className="player-volume-range"
                min={0}
                max={1}
                step="any"
                onChange={this.onChangeVolume.bind(this)}
                value={this.state.volume}
              />
            </div>
          </div>
        </div>
        <button className="ls-button" onClick={this.onClickPlay.bind(this)}>
          <Icon name="live-stream" size="md" />
        </button>
      </div>
    );
  }
}

Player.defaultProps = {
  forcePause: false,
};

Player.propTypes = {
  forcePause: PropTypes.bool,
};

export default Player;



// WEBPACK FOOTER //
// ./src/app/component/player/player.js